// extracted by mini-css-extract-plugin
export default {"clearIcon":"Filters_clearIcon__iIPrH"};